import { render, staticRenderFns } from "./Match.vue?vue&type=template&id=f35987c2&lang=pug"
import script from "./Match.vue?vue&type=script&lang=js"
export * from "./Match.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports